module.exports = __webpack_public_path__ + "img/datagrapes.e7413f2b.svg";